import React, { useState, useEffect, useRef } from "react";
import {
  List,
  BoxArrowRight,
  SunFill,
  MoonStarsFill,
  ArrowLeftRight,
  Check,
  ArrowDownShort,
  X,
  ChevronRight,
  Globe,
  Search,
  Person,
  ChevronLeft,
  Calendar,
  Key,
  Trash,
  BarChart,
  FileEarmarkText,
} from "react-bootstrap-icons";
import { authActions, store } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import LanguageSwitcher from "../../utils/LanguageSwitcher";
import { decryptData } from "../../utils/crypto";
import { getAllStore, getSwitchStore } from "../../services/commonServices";
import Utils from "../../utils";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import CONFIG from "../../config";
import i18n from "../../utils/i18n";
import { notify } from "../Common/Alerts";
import { logout } from "../../services/authServices";
import { Heart } from "lucide-react";

const AdminHeader = ({
  setIsSidebarOpen,
  isSidebarOpen,
  isShowSwitch,
  setIsShowSwitch,
  isMobileMenuOpen,
  setIsMobileMenuOpen,
  setSelectedSProductStore,
  selectedProductStore,
  showSummary,
  setShowSummary,
  setShowCatalogue,
  showCatalogue,
  pinModelOpen,
  setPinModelOpen,
  orderModel,
  setOrderModel,
  customerStoreOwnerData,
  setPinData,
  setUpdateModel,
  setStoreOwnerCart,
  pendingOrderList,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const profileRef = useRef(null);

  let auth = useSelector((x) => x.auth.value);
  let storedData = JSON.parse(localStorage.getItem(CONFIG.login_data));
  let roleId = Number(auth?.user?.role_id);

  const hideMobileNavRoutes = [
    "/customer-store",
    "/order-store-owner",
    "/daily-collection",
    "/order-details",
    "/all-store-owner-order-details",
    "/update-profile-customer",
    "/update-profile-store-owner",
    "/update-store",
    "/add-store",
    "/products-add",
    "/products-update",
    "/owner-store-add",
    "/owner-store-update",
    "/change-password",
    "/pending-order",
    "/delete-account",
    "/product-chart",
    "/customer-report",
    "/fav-product",
  ];

  const shouldHideStore = hideMobileNavRoutes.some((route) =>
    location.pathname.startsWith(route),
  );
  const hideMobileOrderNavRoutes = ["/order-details"];

  const isRouteOrderHidden = hideMobileOrderNavRoutes.some((route) =>
    location.pathname.startsWith(route),
  );

  const hideRoutes = ["/all-store-owner-order-details"];

  const shouldNavigate = hideRoutes.some((route) =>
    location.pathname.startsWith(route),
  );

  // const hideStoreRoutes = ["/add-store", "/update-store"];

  // const shouldStoreNavigate = hideStoreRoutes.some((route) =>
  //   location.pathname.startsWith(route),
  // );

  const [isSwitchLoading, setIsSwitchLoading] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const [storeList, setStoreList] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isLangOpen, setIsLangOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [imgError, setImgError] = useState(false);

  const fullName = auth.user?.full_name || "";
  const initials = fullName
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((name) => name[0].toUpperCase())
    .join("");

  const languageData = [
    { code: "en", name: "English" },
    { code: "hi", name: "Hindi" },
    { code: "gu", name: "Gujrati" },
  ];

  useEffect(() => {
    const savedLanguage = localStorage.getItem("lng") || "en";
    i18n.changeLanguage(savedLanguage);
  }, [i18n]);

  const handleChangeLanguage = (lng) => {
    localStorage.setItem("lng", lng);
    i18n.changeLanguage(lng);
    setIsLangOpen(false);
  };

  const languageDisplay =
    languageData.find((lang) => lang.code === i18n.language)?.name || "English";

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleProfileClick = (e) => {
    e.stopPropagation();
    if (window.innerWidth < 768) {
      setIsMobileMenuOpen(true);
    } else {
      setIsDropdownOpen(!isDropdownOpen);
    }
  };

  const handleSwitchClose = () => {
    setIsShowSwitch(false);
    setSelectedStore(null);
    setSearchTerm("");
  };
  const handleSwitchShow = (e) => {
    setIsShowSwitch(true);
    if (window.innerWidth < 768) {
      setIsMobileMenuOpen(false);
    }
  };

  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    return savedTheme === "dark" ? true : false;
  });

  const handleProductChart = (e) => {
    navigate("/product-chart");
    setIsDropdownOpen(false);

    if (window.innerWidth < 768) {
      setIsMobileMenuOpen(false);
    }
  };

  const handleCustomerReport = (e) => {
    navigate("/customer-report");
    setIsDropdownOpen(false);

    if (window.innerWidth < 768) {
      setIsMobileMenuOpen(false);
    }
  };

  const handleFavProductList = (e) => {
    navigate("/fav-product");
    setIsDropdownOpen(false);

    if (window.innerWidth < 768) {
      setIsMobileMenuOpen(false);
    }
  };

  const handleDailyCollectionShow = (e) => {
    navigate("/daily-collection");
    setIsDropdownOpen(false);

    if (window.innerWidth < 768) {
      setIsMobileMenuOpen(false);
    }
  };

  useEffect(
    function () {
      if (isShowSwitch) {
        getAllStore()
          .then((response) => {
            const decrypted = decryptData(response.data.data);
            setStoreList(decrypted.data);
          })
          .catch((err) => {
            notify.error(Utils.getErrorMessage(err));
          });
      }
    },
    [isShowSwitch],
  );

  useEffect(() => {
    if (storeList?.length && storedData?.active_store_id) {
      const matchedStore = storeList.find(
        (store) => String(store.id) === String(storedData.active_store_id),
      );

      if (matchedStore) {
        setSelectedStore(matchedStore);
      }
    }
  }, [storeList, storedData?.active_store_id]);

  useEffect(() => {
    const root = window.document.documentElement;

    if (isDarkMode) {
      root.classList.add("dark");
      localStorage.setItem("theme", "dark"); // persist
    } else {
      root.classList.remove("dark");
      localStorage.setItem("theme", "light"); // persist
    }
  }, [isDarkMode]);

  const onLogout = (e) => {
    e.preventDefault();

    logout()
      .then((response) => {
        const decrypted = decryptData(response.data.data);
        store.dispatch(authActions.logout());

        localStorage.removeItem("hasVisited");
        localStorage.removeItem(CONFIG.login_data);
        localStorage.removeItem("auth");
        document.documentElement.classList.remove("dark");

        if (roleId === Number(CONFIG.ROLE_ADMIN)) {
          navigate("/secure/login");
        } else {
          navigate("/login");
        }
      })
      .catch((error) => {
        notify.error(Utils.getErrorMessage(error));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleShowLogoutModel = () => {
    setShowLogoutModal(true);
    localStorage.removeItem("cartData");
    localStorage.removeItem("selectedProductStore");
    localStorage.removeItem("customerStoreOwnerData");
    localStorage.removeItem("pinData");
    if (window.innerWidth < 768) {
      setIsMobileMenuOpen(false);
    }
  };

  const handleSwitchStore = (e) => {
    e.preventDefault();
    if (!selectedStore) {
      notify.error("Please select the store.");
      return;
    }

    if (Number(selectedStore.id) === Number(storedData?.active_store_id)) {
      toast.info("This store is already active.");
      return;
    }

    let obj = {
      login_id: auth?.user?.id,
      store_id: selectedStore.id,
    };
    setIsSwitchLoading(true);

    getSwitchStore(obj)
      .then((response) => {
        const decrypted = decryptData(response.data.data);
        let userData = decrypted;
        const storedData = JSON.parse(localStorage.getItem(CONFIG.login_data));

        const updatedData = {
          ...storedData,
          is_store_selected: userData?.is_store_selected,
          active_store_id: userData?.active_store_id,
          store_name: userData?.store_name,

          user: {
            ...storedData.user,
            active_store_id: userData?.active_store_id,
          },
        };
        localStorage.setItem(CONFIG.login_data, JSON.stringify(updatedData));
        window.location.reload(true);
        setIsShowSwitch(false);
        setSearchTerm("");
      })
      .catch((error) => {
        notify.error(Utils.getErrorMessage(error));
      })
      .finally(() => {
        setIsSwitchLoading(false);
      });
  };

  const sortedStoreList = React.useMemo(() => {
    if (!storeList?.length) return [];
    const activeStore = storeList.find(
      (store) => Number(store.id) === Number(storedData?.active_store_id),
    );
    const otherStores = storeList.filter(
      (store) => Number(store.id) !== Number(storedData?.active_store_id),
    );
    return activeStore ? [activeStore, ...otherStores] : storeList;
  }, [storeList, storedData]);

  const filteredStores = sortedStoreList?.filter((store) =>
    store.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const handleUpdateProfile = () => {
    if (roleId === Number(CONFIG.ROLE_OWNER)) {
      navigate("/update-profile-store-owner");
    } else if (roleId === Number(CONFIG.ROLE_CUSTOMER)) {
      navigate("/update-profile-customer");
    } else {
      navigate("/admin-update-profile");
    }
    setIsDropdownOpen(false);
    if (window.innerWidth < 768) {
      setIsMobileMenuOpen(false);
    }
  };

  const handleChangePassword = () => {
    navigate("/change-password");

    setIsDropdownOpen(false);
    if (window.innerWidth < 768) {
      setIsMobileMenuOpen(false);
    }
  };

  const handleDeleteAccount = () => {
    navigate("/delete-account");

    setIsDropdownOpen(false);
    if (window.innerWidth < 768) {
      setIsMobileMenuOpen(false);
    }
  };

  // const getTitle = () => {
  //   if (pinModelOpen) {
  //     return t("securitySetup");
  //   }

  //   if (selectedProductStore) {
  //     if (showSummary) return t("orderSummary");
  //     if (showCatalogue) return selectedProductStore.name;
  //     return t("selectStore");
  //   }

  //   if (location.pathname === "/order-store-owner") {
  //     if (orderModel) {
  //       return customerStoreOwnerData?.name;
  //     }
  //     return t("newOrder");
  //   }

  //   if (location.pathname === "/daily-collection") {
  //     return t("dailyCollection");
  //   }

  //   if (isRouteOrderHidden || shouldNavigate) {
  //     return t("OrderDetails");
  //   }
  //   if (location.pathname === "/update-profile-customer") {
  //     return t("updateCustomer");
  //   }
  //   if (location.pathname === "/update-profile-store-owner") {
  //     return t("updateProfile");
  //   }

  //   if (location.pathname.startsWith("/add-store")) {
  //     return t("addStore");
  //   }

  //   if (location.pathname.startsWith("/update-store")) {
  //     return t("updateStore");
  //   }

  //   if (location.pathname.startsWith("/products-add")) {
  //     return t("addNewProducts");
  //   }

  //   if (location.pathname.startsWith("/products-update")) {
  //     return t("updateProducts");
  //   }

  //   return t("selectStore");
  // };

  // const handleBackClick = () => {
  //   if (showSummary) {
  //     setShowSummary(false);
  //     return;
  //   }

  //   if (showCatalogue && selectedProductStore) {
  //     setShowCatalogue(false);
  //     // localStorage.removeItem("cartData");
  //     return;
  //   }

  //   if (pinModelOpen) {
  //     setPinModelOpen(false);
  //     setSelectedSProductStore(null);
  //     setShowCatalogue(false);
  //     setPinData(null);
  //     setUpdateModel(false);
  //     return;
  //   }

  //   if (location.pathname === "/order-store-owner") {
  //     if (orderModel) {
  //       setOrderModel(false);

  //       return;
  //     }
  //     navigate("/dashboard");
  //     return;
  //   }

  //   if (location.pathname === "/daily-collection") {
  //     navigate("/dashboard");
  //     return;
  //   }

  //   if (isRouteOrderHidden) {
  //     navigate("/order");
  //     return;
  //   }

  //   if (shouldNavigate) {
  //     navigate("/all-store-owner-order-list");
  //     return;
  //   }

  //   if (location.pathname === "/update-profile-customer") {
  //     navigate("/dashboard");
  //     return;
  //   }

  //   if (location.pathname === "/update-profile-store-owner") {
  //     navigate("/dashboard");
  //     return;
  //   }

  //   if (location.pathname.startsWith("/add-store")) {
  //     navigate("/store");
  //     return;
  //   }

  //   if (location.pathname.startsWith("/update-store")) {
  //     navigate("/store");
  //     return;
  //   }

  //   if (location.pathname.startsWith("/products-add")) {
  //     navigate("/products");
  //     return;
  //   }

  //   if (location.pathname.startsWith("/products-update")) {
  //     navigate("/products");
  //     return;
  //   }

  //   setSelectedSProductStore(null);
  //   navigate("/dashboard");
  // };

  // Get page title for header
  const getTitle = () => {
    if (pinModelOpen) return t("securitySetup");
    if (selectedProductStore) {
      if (showSummary) return t("orderSummary");
      if (showCatalogue) return selectedProductStore.name;
      return t("dukaanSetu");
    }

    if (isRouteOrderHidden || shouldNavigate) {
      return t("OrderDetails");
    }
    if (location.pathname === "/order-store-owner") {
      if (orderModel) return customerStoreOwnerData?.name;
      return t("newOrder");
    }
    if (location.pathname === "/daily-collection") return t("dailyCollection");
    if (isRouteOrderHidden) return t("OrderDetails");
    if (location.pathname === "/update-profile-customer")
      return t("updateProfile");
    if (location.pathname === "/update-profile-store-owner")
      return t("updateProfile");
    if (location.pathname.startsWith("/add-store")) return t("addStore");
    if (location.pathname.startsWith("/update-store")) return t("updateStore");
    if (location.pathname.startsWith("/products-add"))
      return t("addNewProducts");
    if (location.pathname.startsWith("/products-update"))
      return t("updateProducts");

    if (location.pathname.startsWith("/owner-store-add"))
      return t("addNewStoreOwner");
    if (location.pathname.startsWith("/owner-store-update"))
      return t("updateNewStoreOwner");
    if (location.pathname.startsWith("/change-password"))
      return t("changePassword");
    if (location.pathname.startsWith("/pending-order")) {
      return `${pendingOrderList?.customer?.name ?? ""}'${t("SOrders")}`;
    }
    if (location.pathname.startsWith("/delete-account"))
      return t("deleteAccount");
    if (location.pathname.startsWith("/product-chart"))
      return t("productChart");
    if (location.pathname.startsWith("/customer-report")) return t("report");
    if (location.pathname.startsWith("/fav-product")) return t("favourite");

    return t("dukaanSetu");
  };

  // Handle app back button click
  const handleBackClick = () => {
    if (showSummary) {
      setShowSummary(false);
      return;
    }

    if (showCatalogue && selectedProductStore) {
      setShowCatalogue(false);
      return;
    }

    if (pinModelOpen) {
      setPinModelOpen(false);
      setSelectedSProductStore(null);
      setShowCatalogue(false);
      setPinData(null);
      setUpdateModel(false);
      return;
    }

    if (location.pathname === "/order-store-owner") {
      if (orderModel) {
        setOrderModel(false);

        return;
      }
      // Clear store selection on going back to dashboard
      setSelectedSProductStore(null);
      localStorage.removeItem("storeOwnerCart");
      setStoreOwnerCart([]);
      navigate("/dashboard");
      return;
    }

    if (location.pathname === "/daily-collection") {
      setSelectedSProductStore(null);
      navigate("/dashboard");
      return;
    }

    if (isRouteOrderHidden) {
      setSelectedSProductStore(null);
      navigate("/order");
      return;
    }

    if (shouldNavigate) {
      setSelectedSProductStore(null);
      navigate("/all-store-owner-order-list");
      return;
    }

    if (
      location.pathname.startsWith("/update-profile-customer") ||
      location.pathname.startsWith("/update-profile-store-owner")
    ) {
      setSelectedSProductStore(null);
      navigate("/dashboard");
      return;
    }

    if (
      location.pathname.startsWith("/add-store") ||
      location.pathname.startsWith("/update-store")
    ) {
      setSelectedSProductStore(null);
      navigate("/store");
      return;
    }

    if (
      location.pathname.startsWith("/owner-store-add") ||
      location.pathname.startsWith("/owner-store-update")
    ) {
      navigate("/owner-store");
      return;
    }

    if (
      location.pathname.startsWith("/products-add") ||
      location.pathname.startsWith("/products-update")
    ) {
      setSelectedSProductStore(null);
      navigate("/products");
      return;
    }

    if (location.pathname.startsWith("/change-password")) {
      navigate("/dashboard");
      return;
    }

    if (location.pathname.startsWith("/pending-order")) {
      navigate("/dashboard");
      return;
    }

    if (location.pathname.startsWith("/delete-account")) {
      navigate("/dashboard");
      return;
    }

    if (location.pathname.startsWith("/product-chart")) {
      navigate("/dashboard");
      return;
    }

    if (location.pathname.startsWith("/customer-report")) {
      navigate("/dashboard");
      return;
    }

    if (location.pathname.startsWith("/fav-product")) {
      navigate("/dashboard");
      return;
    }

    setSelectedSProductStore(null);
    navigate("/dashboard");
  };

  return (
    <header className="h-16 md:h-20 bg-brand-orange dark:bg-[#0f172a] flex items-center justify-between px-4 md:px-10 sticky top-0 z-40 border-b border-white/10 transition-all duration-300">
      <div className="flex items-center">
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className="hidden md:flex p-2 text-white hover:bg-white/10 rounded-xl transition-all items-center justify-center"
        >
          <List size={26} />
        </button>
        {shouldHideStore ? (
          <>
            <div className="flex items-center gap-3 p-4 w-full h-16 sm:hidden">
              <button
                onClick={handleBackClick}
                className="flex items-center justify-center w-8 h-8 rounded-full bg-white dark:bg-slate-800 text-slate-800 dark:text-white shadow-sm dark:shadow-none transition-colors"
              >
                <ChevronLeft size={20} />
              </button>

              <span className="text-white font-black text-md tracking-tight">
                {getTitle()}
              </span>
            </div>
          </>
        ) : (
          <span className="flex sm:hidden text-white font-black text-lg md:text-xl tracking-tight ml-0 md:ml-3">
            {t("dukaanSetu")}
          </span>
        )}
      </div>

      <div className="flex items-center gap-1 sm:gap-4">
        {(selectedStore || Number(auth.user.role_id) === CONFIG.ROLE_OWNER) && (
          <button
            onClick={handleSwitchShow}
            className="hidden p-2 md:px-3 md:py-2 text-white/90 hover:text-white hover:bg-white/10 rounded-xl transition-all items-center gap-2"
          >
            <ArrowLeftRight size={18} />
            <span className="text-sm font-bold">{t("switchStore")}</span>
          </button>
        )}

        <div className="flex items-center gap-1">
          <button
            onClick={() => setIsDarkMode(!isDarkMode)}
            className="hidden md:flex p-2 text-white/80 hover:text-white rounded-xl transition-all"
          >
            {isDarkMode ? <SunFill size={20} /> : <MoonStarsFill size={20} />}
          </button>
        </div>

        <div className="scale-90 md:scale-100 hidden md:flex">
          <LanguageSwitcher />
        </div>

        <div className="relative ml-2 flex items-center gap-3" ref={profileRef}>
          {Number(auth.user.role_id) === CONFIG.ROLE_OWNER && (
            <div className="hidden text-right">
              <p className="text-[10px] text-white/60 dark:text-slate-400 font-black uppercase tracking-widest leading-none mb-1">
                {t("activeStore")}
              </p>
              <p className="text-sm font-extrabold text-white leading-tight max-w-[150px] truncate">
                {storedData?.store_name || "Select Store"}
              </p>
            </div>
          )}
          {/* {!shouldHideStore && ( */}
          <button
            className="flex items-center gap-2 p-1 md:p-1.5 rounded-2xl bg-white/20 md:bg-white dark:bg-slate-800 border border-white/30 md:border-transparent transition-all active:scale-95 hover:bg-white/30 md:hover:shadow-lg group"
            onClick={handleProfileClick}
          >
            <div className="w-8 h-8 md:w-9 md:h-9 rounded-xl overflow-hidden">
              {auth.user?.profile && !imgError ? (
                <img
                  src={auth.user.profile}
                  alt="profile"
                  className="w-full h-full object-cover"
                  onError={() => setImgError(true)}
                />
              ) : (
                <div className="w-full h-full bg-brand-orange md:bg-brand-orange/10 dark:bg-brand-orange/20 flex items-center justify-center text-white md:text-brand-orange font-black text-sm">
                  {initials || "S"}
                </div>
              )}
            </div>

            <ArrowDownShort
              size={20}
              className={`hidden md:block text-slate-400 transition-transform duration-200 ${isDropdownOpen ? "rotate-180" : ""}`}
            />
          </button>

          {/* )} */}

          {isDropdownOpen && (
            <div className="absolute right-0 top-12 w-64 bg-white dark:bg-slate-900 rounded-2xl shadow-[0_10px_40px_-10px_rgba(0,0,0,0.2)] border border-slate-100 dark:border-slate-800 p-2 z-50 mt-3 animate-in fade-in zoom-in duration-200">
              {/* Store Name Section (Mobile Only) */}
              <div className="px-4 py-3 border-b border-slate-50 dark:border-slate-800/50 mb-1 sm:hidden">
                <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
                  {auth.store_name}
                </p>
              </div>

              <div className="space-y-0.5">
                {/* Profile */}
                <button
                  className="group flex items-center gap-3 w-full px-3 py-2.5 rounded-xl hover:bg-orange-50 dark:hover:bg-orange-500/10 transition-all duration-200"
                  onClick={handleUpdateProfile}
                >
                  <div className="p-2 bg-slate-50 dark:bg-slate-800 group-hover:bg-white dark:group-hover:bg-slate-700 rounded-lg shadow-sm transition-colors">
                    <Person
                      size={18}
                      className="text-slate-600 dark:text-slate-400 group-hover:text-orange-600"
                    />
                  </div>
                  <span className="text-sm font-bold text-slate-700 dark:text-slate-200 group-hover:text-orange-700 dark:group-hover:text-orange-400">
                    {t("profile")}
                  </span>
                </button>

                {/* Daily Collection - Role Protected */}
                {Number(auth.user.role_id) === CONFIG.ROLE_OWNER && (
                  <button
                    className="group flex items-center gap-3 w-full px-3 py-2.5 rounded-xl hover:bg-orange-50 dark:hover:bg-orange-500/10 transition-all duration-200"
                    onClick={handleDailyCollectionShow}
                  >
                    <div className="p-2 bg-slate-50 dark:bg-slate-800 group-hover:bg-white dark:group-hover:bg-slate-700 rounded-lg shadow-sm transition-colors">
                      <Calendar
                        size={18}
                        className="text-slate-600 dark:text-slate-400 group-hover:text-orange-600"
                      />
                    </div>
                    <span className="text-sm font-bold text-slate-700 dark:text-slate-200 group-hover:text-orange-700 dark:group-hover:text-orange-400">
                      {t("dailyCollection")}
                    </span>
                  </button>
                )}

                {/* Change Password */}
                {Number(storedData?.user?.role_id) ===
                  Number(CONFIG.ROLE_ADMIN) && (
                  <button
                    className="group flex items-center gap-3 w-full px-3 py-2.5 rounded-xl hover:bg-orange-50 dark:hover:bg-orange-500/10 transition-all duration-200"
                    onClick={handleChangePassword}
                  >
                    <div className="p-2 bg-slate-50 dark:bg-slate-800 group-hover:bg-white dark:group-hover:bg-slate-700 rounded-lg shadow-sm transition-colors">
                      <Key
                        size={18}
                        className="text-slate-600 dark:text-slate-400 group-hover:text-orange-600"
                      />
                    </div>
                    <span className="text-sm font-bold text-slate-700 dark:text-slate-200 group-hover:text-orange-700 dark:group-hover:text-orange-400">
                      {t("changePassword")}
                    </span>
                  </button>
                )}

                {/* Delete Account - Conditional */}
                {Number(storedData?.delete_account_show) === 1 && (
                  <button
                    className="group flex items-center gap-3 w-full px-3 py-2.5 rounded-xl hover:bg-red-50 dark:hover:bg-red-500/10 transition-all duration-200"
                    onClick={handleDeleteAccount}
                  >
                    <div className="p-2 bg-slate-50 dark:bg-slate-800 group-hover:bg-white dark:group-hover:bg-slate-700 rounded-lg shadow-sm transition-colors">
                      <Trash
                        size={18}
                        className="text-slate-600 dark:text-slate-400 group-hover:text-red-600"
                      />
                    </div>
                    <span className="text-sm font-bold text-slate-700 dark:text-slate-200 group-hover:text-red-700 dark:group-hover:text-red-400">
                      {t("deleteAccount")}
                    </span>
                  </button>
                )}

                <div className="my-2 border-t border-slate-50 dark:border-slate-800" />

                {/* Log Out */}
                <button
                  className="group flex items-center gap-3 w-full px-3 py-2.5 rounded-xl hover:bg-slate-100 dark:hover:bg-slate-800 transition-all duration-200"
                  onClick={handleShowLogoutModel}
                >
                  <div className="p-2 bg-slate-50 dark:bg-slate-800 group-hover:bg-white dark:group-hover:bg-slate-700 rounded-lg shadow-sm transition-colors">
                    <BoxArrowRight
                      size={18}
                      className="text-slate-600 dark:text-slate-400 group-hover:text-orange-600"
                    />
                  </div>
                  <span className="text-sm font-bold text-slate-700 dark:text-slate-200 group-hover:text-slate-900">
                    {t("logOut")}
                  </span>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-[100] bg-slate-50 dark:bg-[#0f172a] md:hidden flex flex-col animate-in slide-in-from-right duration-300">
          <div className="flex items-center justify-between px-4 h-16 bg-white dark:bg-[#0f172a] border-b border-slate-100 dark:border-white/5">
            <button
              onClick={() => setIsMobileMenuOpen(false)}
              className="p-2 -ml-2 text-slate-600 dark:text-slate-300"
            >
              <ChevronLeft size={24} />
            </button>
            <h1 className="font-bold text-lg text-slate-800 dark:text-white">
              {t("settings")}
            </h1>
            <div className="w-8" />
          </div>
          <div className="flex-1 overflow-y-auto p-4 space-y-6">
            <section>
              {Number(auth.user.role_id) === CONFIG.ROLE_OWNER && (
                <h2 className="text-[11px] font-bold text-slate-400 uppercase tracking-widest mb-2 px-2">
                  {t("personalization")}
                </h2>
              )}

              <div className="bg-white dark:bg-slate-800 rounded-2xl overflow-hidden shadow-sm border border-slate-100 dark:border-white/5">
                {(selectedStore ||
                  Number(auth.user.role_id) === CONFIG.ROLE_OWNER) && (
                  <button
                    onClick={handleSwitchShow}
                    className="hidden w-full flex items-center justify-between p-4 active:bg-slate-100 dark:active:bg-white/5"
                  >
                    <div className="flex items-center gap-4">
                      <span className="text-slate-400 text-lg">
                        <ArrowLeftRight />
                      </span>
                      <span className="text-sm font-bold text-slate-700 dark:text-slate-200">
                        {t("switchStore")}
                      </span>
                    </div>
                    <ChevronRight size={14} className="text-slate-300" />
                  </button>
                )}

                <div className="bg-white dark:bg-slate-800 rounded-2xl overflow-hidden shadow-sm border border-slate-100 dark:border-white/5">
                  <button
                    onClick={() => setIsLangOpen(!isLangOpen)}
                    className={`w-full flex items-center justify-between p-4 transition-colors ${
                      isLangOpen ? "bg-slate-50/50 dark:bg-slate-900/40" : ""
                    }`}
                  >
                    <div className="flex items-center gap-4">
                      <div className="w-8 h-8 rounded-lg bg-blue-50 dark:bg-blue-900/30 text-blue-500 flex items-center justify-center">
                        <Globe size={18} />
                      </div>
                      <span className="text-sm font-bold text-slate-700 dark:text-slate-200">
                        {t("language")}
                      </span>
                    </div>
                    <div className="flex items-center gap-3">
                      <span className="text-xs font-bold text-brand-orange uppercase">
                        {languageDisplay}
                      </span>
                      <ChevronRight
                        size={14}
                        className={`text-slate-300 transition-transform duration-300 ${isLangOpen ? "rotate-90" : ""}`}
                      />
                    </div>
                  </button>

                  {isLangOpen && (
                    <div className="bg-slate-50/80 dark:bg-slate-900/60 px-4 pb-3 animate-in slide-in-from-top duration-200">
                      <div className="space-y-1 mt-1">
                        {languageData.map((lang) => {
                          const isActive = languageDisplay === lang.code;
                          return (
                            <button
                              key={lang.code}
                              className={`w-full flex items-center justify-between px-4 py-3 rounded-xl transition-all ${
                                isActive
                                  ? "bg-white dark:bg-slate-800 shadow-sm border border-slate-100 dark:border-white/5"
                                  : "hover:bg-white/50 dark:hover:bg-slate-800/40"
                              }`}
                              onClick={() => {
                                handleChangeLanguage(lang.code);
                                setIsLangOpen(false);
                              }}
                            >
                              <div className="flex items-center gap-3">
                                <div
                                  className={`w-1.5 h-1.5 rounded-full ${isActive ? "bg-brand-orange" : "bg-slate-300"}`}
                                />
                                <span
                                  className={`text-sm ${isActive ? "font-bold text-slate-800 dark:text-white" : "font-medium text-slate-500"}`}
                                >
                                  {lang.name}
                                </span>
                              </div>

                              {isActive && (
                                <Check
                                  size={16}
                                  className="text-brand-orange"
                                />
                              )}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-[11px] font-bold text-slate-400 uppercase tracking-widest mb-2 px-2">
                {t("aboutTheApp")}
              </h2>

              <div className="bg-white dark:bg-slate-800 rounded-2xl overflow-hidden shadow-sm border border-slate-100 dark:border-white/5">
                <button
                  className="w-full flex items-center justify-between p-4 active:bg-slate-100 dark:active:bg-white/5 border-b border-slate-50 dark:border-white/5"
                  onClick={handleUpdateProfile}
                >
                  <div className="flex items-center gap-4">
                    <span className="text-slate-400 text-lg">
                      <Person size={20} />
                    </span>
                    <span className="text-sm font-bold text-slate-700 dark:text-slate-200">
                      {t("profile")}
                    </span>
                  </div>
                  <ChevronRight size={14} className="text-slate-300" />
                </button>

                <button
                  className="w-full flex items-center justify-between p-4 active:bg-slate-100 dark:active:bg-white/5 border-b border-slate-50 dark:border-white/5"
                  onClick={() => setIsDarkMode(!isDarkMode)}
                >
                  <div className="flex items-center gap-4">
                    <span className="text-slate-400 text-lg">
                      {isDarkMode ? (
                        <SunFill size={20} />
                      ) : (
                        <MoonStarsFill size={20} />
                      )}{" "}
                    </span>
                    <span className="text-sm font-bold text-slate-700 dark:text-slate-200">
                      {isDarkMode ? t("lightMode") : t("darkMode")}
                    </span>
                  </div>
                  <ChevronRight size={14} className="text-slate-300" />
                </button>

                <div className="bg-white dark:bg-slate-800 rounded-2xl overflow-hidden shadow-sm border border-slate-100 dark:border-white/5">
                  {/* <button
                    onClick={() => setOpenNotification(!openNotification)}
                    className="w-full flex items-center justify-between p-4 active:bg-slate-100 dark:active:bg-white/5 border-b border-slate-50 dark:border-white/5"
                  >
                    <div className="flex items-center gap-4">
                      <span className="text-slate-400 text-lg">
                        <Bell size={20} />
                      </span>
                      <span className="text-sm font-bold text-slate-700 dark:text-slate-200">
                        {t("notification")}
                      </span>
                    </div>

                    <ChevronRight
                      size={14}
                      className={`text-slate-300 transition-transform ${
                        openNotification ? "rotate-90" : ""
                      }`}
                    />
                  </button> */}

                  {Number(auth.user.role_id) === CONFIG.ROLE_OWNER && (
                    <>
                      <button
                        className="w-full flex items-center justify-between p-4 active:bg-slate-100 dark:active:bg-white/5 border-b border-slate-50 dark:border-white/5"
                        onClick={handleDailyCollectionShow}
                      >
                        <div className="flex items-center gap-4">
                          <span className="text-slate-400 text-lg">
                            <Calendar size={20} />
                          </span>
                          <span className="text-sm font-bold text-slate-700 dark:text-slate-200">
                            {t("dailyCollection")}
                          </span>
                        </div>
                        <ChevronRight size={14} className="text-slate-300" />
                      </button>

                      <button
                        className="w-full flex items-center justify-between p-4 active:bg-slate-100 dark:active:bg-white/5 border-b border-slate-50 dark:border-white/5"
                        onClick={handleFavProductList}
                      >
                        <div className="flex items-center gap-4">
                          <span className="text-slate-400 text-lg">
                            <Heart size={20} />
                          </span>
                          <span className="text-sm font-bold text-slate-700 dark:text-slate-200">
                            {t("favouriteProduct")}
                          </span>
                        </div>
                        <ChevronRight size={14} className="text-slate-300" />
                      </button>

                      <button
                        className="w-full flex items-center justify-between p-4 active:bg-slate-100 dark:active:bg-white/5 border-b border-slate-50 dark:border-white/5"
                        onClick={handleProductChart}
                      >
                        <div className="flex items-center gap-4">
                          <span className="text-slate-400 text-lg">
                            <BarChart size={20} />
                          </span>
                          <span className="text-sm font-bold text-slate-700 dark:text-slate-200">
                            {t("productChart")}
                          </span>
                        </div>
                        <ChevronRight size={14} className="text-slate-300" />
                      </button>

                      <button
                        className="w-full flex items-center justify-between p-4 active:bg-slate-100 dark:active:bg-white/5 border-b border-slate-50 dark:border-white/5"
                        onClick={handleCustomerReport}
                      >
                        <div className="flex items-center gap-4">
                          <span className="text-slate-400 text-lg">
                            <FileEarmarkText size={20} />
                          </span>
                          <span className="text-sm font-bold text-slate-700 dark:text-slate-200">
                            {t("report")}
                          </span>
                        </div>
                        <ChevronRight size={14} className="text-slate-300" />
                      </button>
                    </>
                  )}
                  {Number(storedData?.user?.role_id) ===
                    Number(CONFIG.ROLE_ADMIN) && (
                    <button
                      className="w-full flex items-center justify-between p-4 active:bg-slate-100 dark:active:bg-white/5 border-b border-slate-50 dark:border-white/5"
                      onClick={handleChangePassword}
                    >
                      <div className="flex items-center gap-4">
                        <span className="text-slate-400 text-lg">
                          <Key size={20} />
                        </span>
                        <span className="text-sm font-bold text-slate-700 dark:text-slate-200">
                          {t("changePassword")}
                        </span>
                      </div>
                      <ChevronRight size={14} className="text-slate-300" />
                    </button>
                  )}

                  {Number(storedData?.delete_account_show) === 1 && (
                    <button
                      className="w-full flex items-center justify-between p-4 active:bg-slate-100 dark:active:bg-white/5 border-b border-slate-50 dark:border-white/5"
                      onClick={handleDeleteAccount}
                    >
                      <div className="flex items-center gap-4">
                        <span className="text-slate-400 text-lg">
                          <Trash size={20} />
                        </span>
                        <span className="text-sm font-bold text-slate-700 dark:text-slate-200">
                          {t("deleteAccount")}
                        </span>
                      </div>
                      <ChevronRight size={14} className="text-slate-300" />
                    </button>
                  )}
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-[11px] font-bold text-slate-400 uppercase tracking-widest mb-2 px-2">
                {t("more")}
              </h2>

              <div className="bg-white dark:bg-slate-800 rounded-2xl overflow-hidden shadow-sm border border-slate-100 dark:border-white/5">
                <button
                  onClick={handleShowLogoutModel}
                  className="w-full flex items-center justify-between p-4 active:bg-slate-100 dark:active:bg-white/5 border-b border-slate-50 dark:border-white/5"
                >
                  <div className="flex items-center gap-4">
                    <span className="text-slate-400 text-lg">
                      <BoxArrowRight />
                    </span>
                    <span className="text-sm font-bold text-slate-700 dark:text-slate-200">
                      {t("logOut")}
                    </span>
                  </div>
                  <ChevronRight size={14} className="text-slate-300" />
                </button>
              </div>
            </section>
          </div>
        </div>
      )}

      {isShowSwitch && (
        <div
          className="fixed inset-0 z-500 flex items-center justify-center bg-black/70 backdrop-blur-md p-4 animate-in fade-in duration-300"
          style={{ pointerEvents: "auto" }}
        >
          <div className="bg-white dark:bg-[#0f172a] rounded-[32px] shadow-2xl w-full max-w-lg overflow-hidden border border-white/10 flex flex-col max-h-[90vh]">
            <div className="bg-brand-orange p-6 text-white text-center shrink-0">
              <h2 className="text-2xl font-black tracking-tight">
                {t("switchStore")}
              </h2>
              <p className="text-orange-100 text-sm mt-1 font-medium">
                {t("switchStoreTitle")}
              </p>
            </div>

            <div className="px-6 pt-6 pb-2 shrink-0">
              <div className="relative group">
                <div className="absolute inset-y-0 left-4 flex items-center pointer-events-none">
                  <Search
                    size={18}
                    className="text-slate-400 group-focus-within:text-brand-orange transition-colors"
                  />
                </div>
                <input
                  type="text"
                  placeholder="Search store name..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full bg-slate-50 dark:bg-white/5 border-2 border-slate-100 dark:border-white/5 rounded-2xl py-4 pl-12 pr-10 text-sm font-bold text-slate-700 dark:text-white placeholder:text-slate-400 focus:border-brand-orange focus:bg-white dark:focus:bg-slate-800 transition-all outline-none shadow-sm"
                />
                {searchTerm && (
                  <button
                    onClick={() => setSearchTerm("")}
                    className="absolute inset-y-0 right-4 flex items-center text-slate-400 hover:text-brand-orange"
                  >
                    <X size={18} />
                  </button>
                )}
              </div>
            </div>

            <div className="p-6 flex flex-col overflow-hidden">
              <div
                className="grid grid-cols-1 gap-3 overflow-y-auto pr-2 custom-scrollbar-orange"
                style={{
                  maxHeight: "290px",
                  scrollbarWidth: "thin",
                  scrollbarColor: "#ff6b00 transparent",
                }}
              >
                {filteredStores?.map((store) => (
                  <button
                    key={store.id}
                    onClick={() => setSelectedStore(store)}
                    className={`flex items-center gap-4 p-4 rounded-2xl border-2 transition-all duration-200 group shrink-0 ${
                      selectedStore?.id === store.id
                        ? "border-brand-orange bg-orange-50 dark:bg-orange-500/10 shadow-md"
                        : "border-slate-100 dark:border-white/5 hover:border-orange-200 dark:hover:border-white/20 hover:bg-slate-50 dark:hover:bg-white/5"
                    }`}
                  >
                    <div
                      className={`w-12 h-12 rounded-xl flex items-center justify-center font-black text-lg transition-all shrink-0 ${
                        selectedStore?.id === store.id
                          ? "bg-brand-orange text-white scale-105 shadow-lg shadow-orange-500/20"
                          : "bg-slate-100 dark:bg-white/10 text-slate-500 dark:text-slate-400 group-hover:bg-orange-100 group-hover:text-brand-orange"
                      }`}
                    >
                      {store.name.charAt(0).toUpperCase()}
                    </div>

                    <div className="flex-1 text-left min-w-0">
                      <h3
                        className={`font-black text-sm uppercase tracking-wide truncate ${
                          selectedStore?.id === store.id
                            ? "text-brand-orange"
                            : "text-slate-700 dark:text-slate-200"
                        }`}
                      >
                        {store.name}
                      </h3>
                      <div className="flex flex-col mt-0.5">
                        <span className="text-[10px] text-slate-400 font-bold uppercase truncate">
                          {t("address")}: {store.address}
                        </span>
                        <span className="text-[10px] text-slate-400 font-bold uppercase">
                          {t("pinCode")}: {store.pincode}
                        </span>
                      </div>
                    </div>

                    {selectedStore?.id === store.id && (
                      <div className="w-6 h-6 rounded-full bg-brand-orange flex items-center justify-center shrink-0">
                        <Check size={14} className="text-white" />
                      </div>
                    )}
                  </button>
                ))}
              </div>

              <div className="flex gap-3 mt-8 pt-4 border-t border-slate-100 dark:border-white/5 shrink-0">
                <button
                  onClick={handleSwitchClose}
                  className="btn-filter-close flex-1"
                >
                  {t("close")}
                </button>

                <button
                  onClick={handleSwitchStore}
                  disabled={
                    !selectedStore ||
                    isSwitchLoading ||
                    Number(selectedStore.id) ===
                      Number(storedData?.active_store_id)
                  }
                  className="flex-[2] py-4 bg-brand-orange text-white rounded-2xl font-black uppercase text-[10px] tracking-[0.2em] shadow-lg shadow-orange-500/30 active:scale-95 transition-all disabled:opacity-50 disabled:grayscale"
                >
                  {isSwitchLoading ? t("switchingLoading") : t("switchToStore")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showLogoutModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div className="bg-white dark:bg-[#161e2d] rounded-3xl p-6 w-[90%] max-w-sm shadow-2xl animate-fade-in">
            <h2 className="text-lg font-bold text-gray-800 dark:text-white mb-2">
              Confirm Logout?
            </h2>

            <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">
              You will be logged out of your account and need to login again.
            </p>

            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowLogoutModal(false)}
                className="px-4 py-2 rounded-xl bg-gray-100 dark:bg-slate-700 text-gray-700 dark:text-gray-200 font-semibold hover:bg-gray-200 transition"
              >
                Cancel
              </button>

              <button
                onClick={(e) => {
                  setShowLogoutModal(false);
                  onLogout(e);
                }}
                className="px-4 py-2 rounded-xl bg-red-500 text-white font-semibold hover:bg-red-600 transition"
              >
                Yes, Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default AdminHeader;
